import SiteConfig from '../../../model/SiteConfig'
import {
  saveSiteConfig as apiSaveSiteConfig,
  loadSiteConfig
} from '../../../rest-api/SiteConfig-api'
import { Dispatch } from 'redux'
import { actionCreatorFactory, AnyAction } from 'typescript-fsa'
import wrapAsyncWorker from '../../../common/wrapAsyncWorker'
import ValidationError from '../../../common/ValidationError'

const actionCreator = actionCreatorFactory()

export const SaveSiteConfig = actionCreator.async<SiteConfig, SiteConfig, { message: string, errors: ValidationError[] }>(
  'SaveSiteConfig'
)

const saveSiteConfigWorker = wrapAsyncWorker(
  SaveSiteConfig,
  (params: SiteConfig): Promise<SiteConfig> =>
    apiSaveSiteConfig(params)
      .then(() => loadSiteConfig(params.key))
)

export const saveSiteConfig = (siteConfig: SiteConfig) => {
  return (dispatch: Dispatch<AnyAction>) => saveSiteConfigWorker(dispatch, siteConfig)
}
